module.exports = __webpack_public_path__ + "static/media/logo.ef3e2537.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 22
// module chunks = 0